<template>
  <div id="app">
    <app-header></app-header>
    <template>
      <app-features></app-features>
      <!-- <app-download></app-download> -->
      <app-commodity></app-commodity>
      <app-testimonials></app-testimonials>
      <app-contact></app-contact>
    </template>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFeatures from "./components/AppFeatures.vue";
import AppTestimonials from "./components/AppTestimonials.vue";
import AppFooter from "./components/AppFooter.vue";
import AppContact from "./components/AppContact.vue";
import AppDownload from "./components/AppDownload.vue";
import AppCommodity from "./components/AppCommodity.vue";

export default {
  components: {
    AppHeader,
    AppFeatures,
    AppTestimonials,
    AppFooter,
    AppContact,
    AppDownload,
    AppCommodity
  },
  data() {
      return {
          isCommodity: false
      };
  },
  watch: {
    '$route': (val) => {
        console.log('routeroute', val)
        this.isCommodity = val.path === '/commodity'
    }
  }
};
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
